<template>
    <div class="font-weight-medium">
        <span
            v-if="location === 'sidebar'"
            v-html="'('"
        /><a
            href="#"
            class="habiteo-body-2 text-none convert-cta grey-text"
            :class="{'active': areaUnit === 'sq ft'}"
            @click.stop="convertAreaUnit('sq ft')"
            v-html="'Sq ft'"
        />
        /
        <a
            href="#"
            class="habiteo-body-2 text-none convert-cta grey-text"
            :class="{'active': areaUnit === 'sq m'}"
            @click.stop="convertAreaUnit('sq m')"
            v-html="'Sq m'"
        /><span
            v-if="location === 'sidebar'"
            v-html="')'"
        />
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';

    export default {
        name: "SwitchAreaUnit",
        props: {
            location: {
                type: String,
                required: false
            },
            areaUnit: {
                type: String,
                required: true
            }
        },
        methods: {
            convertAreaUnit(unit) {
                EventBus.$emit('convertAreaUnit', unit);
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/_common.scss";
</style>


// WEBPACK FOOTER //
// src/components/filters/SwitchAreaUnit.vue